// extracted by mini-css-extract-plugin
export default {"Dashboard":"Dashboard_Dashboard__mtrtf","Body":"Dashboard_Body__yaA2m","SideTabNavigation":"Dashboard_SideTabNavigation__Z3COp","mainBodyScreen":"Dashboard_mainBodyScreen__BPd8D"};